export const paymentStatus = [
  {
    code: 1,
    label: 'pending',
    labelIcon: 'eva:shopping-cart-fill',
    group: 'active',
    step: 'receive',
    stepAction: 'paymentPending',
    action: 'pay',
    actionIcon: 'mdi:delete-variant',
  },
  {
    code: 2,
    label: 'partially.paid',
    labelIcon: 'eva:clock-fill',
    group: 'active',
    step: 'startPayment',
    stepAction: 'startedPayment',
    action: 'setReady',
    actionIcon: 'eva:bell-fill',
  },
  {
    code: 3,
    label: 'paid',
    labelIcon: 'eva:checkmark-circle-2-fill',
    group: 'inactive',
    step: 'fulfill',
    stepAction: 'paid',
    action: '',
    actionIcon: '',
  },
  {
    code: 4,
    label: 'failed',
    labelIcon: 'eva:close-circle-fill',
    group: 'failed',
    step: 'fail',
    stepAction: 'paymentFailed',
    action: '',
    actionIcon: '',
  },
  {
    code: 5,
    label: 'refunded',
    labelIcon: 'ic:round-settings-backup-restore',
    group: 'refunded',
    step: 'refund',
    stepAction: 'paymentRefunded',
    action: '',
    actionIcon: '',
  },
  {
    code: 6,
    label: 'canceled',
    labelIcon: 'eva:close-circle-fill',
    group: 'canceled',
    step: 'cancel',
    stepAction: 'paymentCanceled',
    action: '',
    actionIcon: '',
  },
];

export const inactivePayments = paymentStatus
  .filter((status) => status.group === 'inactive' || status.group === 'canceled')
  .map((status) => status.code.toString());

export const activePayments = paymentStatus
  .filter((status) => status.group === 'active')
  .map((status) => status.code.toString());

export const allPayments = paymentStatus.map((status) => status.code.toString());

export const refundedPayments = paymentStatus
  .filter((status) => status.group === 'refunded')
  .map((status) => status.code.toString());

export const failedPayments = paymentStatus
  .filter((status) => status.group === 'failed')
  .map((status) => status.code.toString());
